import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderTabService } from '../../shared/components/header-tabs/header-tab.service';

@Component({
    selector: 'convfact-expensetabs',
    templateUrl: './expense-tabs.component.html',
    styleUrls: ['./expense-tabs.component.scss'],
    standalone: false
})

export class ExpenseTabsComponent implements OnInit {
  routes: any[];

  isSelected = false;
  isResponsive: boolean;

  constructor(private router: Router,
    private headerTabService: HeaderTabService
  ) {
    this.routes = [
      { label: 'Recibidos', link: '/expense/list', enable: true },
      { label: 'Nóminas', link: '/expense/salary', enable: true },
      { label: 'Autónomo', link: '/expense/selfemployed', enable: true },
      { label: 'Anticipos a proveedores', link: '/expense/advancepayment/provider', enable: true },
      { label: 'Gastos bancarios', link: '/expense/bankcharges', enable: true },
      { label: 'IRPF Soportado', link: '/expense/irpf', enable: true },
      { label: 'Estadisticas', link: '/expense/statistics', enable: true },
      { label: 'Correos IA', link: '/expense/correos-ia', enable: true },
      // { label: 'Reconocimiento facturas con IA', link: '/expense/ia', enable: true },
    ];
  }

  ngOnInit() {
    this.headerTabService.onEventSubject.subscribe(result => {
      const event = result.event;

      switch (event) {
        case 'on-select-tab':
          this.isSelected = true;
          break;
        case 'on-select-back':
          this.isSelected = false;
          break;
        case 'on-change-responsive':
          this.isResponsive = result.isResponsive;
          break;
      }
    });

  }

  onBack() {
    this.isSelected = false;
    this.headerTabService.onEvent({ event: 'on-select-back' });
  }
}
